// voiceDeltaBridge — bridges the agent loop's token stream to the hands-free
// voice pump for low-latency speech. Extracted from SessionWorkspace so the
// spine's DP/LOC stays at baseline (dp-loc-ratchet).
//
// When a voice session is open (window.__apoloHandsFree, set by useHandsFreeMode)
// and a streamed token CLOSES a sentence, we dispatch apolo:handsFreeReplyDelta
// with the full text so far. The voice hook dedupes by sentence and speaks the
// first sentence while the LLM is still generating the rest — so the reply is
// heard almost immediately instead of after the whole turn settles. Cheap:
// ~1 event per sentence, and a no-op entirely when voice is off.

const SENTENCE_BOUNDARY = /[.!?…\n]/;

/**
 * @param {{ type?: string, delta?: string }} evt  the loop event
 * @param {string} fullText  the accumulated assistant text so far
 */
export function emitVoiceDelta(evt, fullText) {
  if (!evt || evt.type !== 'token') return;
  if (typeof window === 'undefined') return;
  const w = /** @type {*} */ (window);
  if (!w.__apoloHandsFree) return;
  // Fire when THIS delta closes a sentence, OR when the accumulated text now
  // ends on a boundary (sentence end can straddle tokens — waiting only on
  // evt.delta delayed the first spoken sentence).
  const delta = evt.delta || '';
  const text = String(fullText || '');
  if (!SENTENCE_BOUNDARY.test(delta) && !/[.!?…]\s*$/.test(text)) return;
  w.dispatchEvent(new CustomEvent('apolo:handsFreeReplyDelta', { detail: { text } }));
}
